import React from 'react';
import type { Place } from '../../types';
import { PlaceCard } from './PlaceCard';
import { EmptyState } from '../common/EmptyState';
import { LoadingSpinner } from '../common/LoadingSpinner';

interface PlaceListProps {
  places: Place[];
  favorites: string[];
  isLoading?: boolean;
  emptyType?: 'search' | 'favorites';
  onSelectPlace: (place: Place) => void;
  onToggleFavorite: (placeId: string) => void;
  onCreatePlace?: () => void;
}

export function PlaceList({
  places,
  favorites,
  isLoading = false,
  emptyType = 'search',
  onSelectPlace,
  onToggleFavorite,
  onCreatePlace,
}: PlaceListProps) {
  if (isLoading) {
    return (
      <div className="py-12">
        <LoadingSpinner size="lg" />
      </div>
    );
  }

  if (places.length === 0) {
    return (
      <EmptyState
        type={emptyType}
        action={
          onCreatePlace && emptyType === 'search'
            ? { label: 'Ort vorschlagen', onClick: onCreatePlace }
            : undefined
        }
      />
    );
  }

  return (
    <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
      {places.map((place) => (
        <PlaceCard
          key={place.id}
          place={place}
          isFavorite={favorites.includes(place.id)}
          onSelect={onSelectPlace}
          onToggleFavorite={onToggleFavorite}
        />
      ))}
    </div>
  );
}
